export enum HelperSocketMsgType {
  MsgTypeNone,
  MsgTypeRegister,
  MsgTypeConfigure,
  MsgTypeInstall,
  MsgTypeLaunch,
  MsgTypeApltStatus,
  MsgTypeReportProgress,
  MsgTypeStateChanged,
  MsgTypeInstallStop,
  MsgTypeSetConfigure,  // 设置配置(语言)
  MsgTypeReport,        // 广播变化d
  MsgTypeExit,
  MsgTypeLatestVersion = 0x0c,
  MsgTypeStats = 0x0d,
  MsgTypeLaunchAplt = 0x0e,
  MsgTypeAppVersion = 0x0f,
  MsgTypeAppIrokPath = 0x17,
  MsgTypeAppMsgType = 0x20,
  MsgTypeInstallVersion = 0x23,  //安装/或更新最新版本
}
export interface HelperSocketMsg<T> {
  ID: string;
  Type: HelperSocketMsgType;
  Data: T;
  Err: string;
  Forward: string; //转发至APP ID ,有转发的情况, ast.daemon不会处理消息
  From: string;
}
